export default __webpack_public_path__ + "static/MeshMate-of-the-Year-2020-Nihkil-Ladha-0d094c9f90a122e550732643162642fa.webp";